import { Component } from '@angular/core';

@Component({
	selector: 'icons-cmp',
	moduleId: module.id,
	templateUrl: 'icons.component.html'
})
export class IconsComponent {}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/icons/icons.component.ts